import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop'; 

import { AtosRoutingModule } from './atos-routing.module';
import { EditarAtoComponent } from './components/editar-ato/editar-ato.component';
import { FormularioAtoComponent } from './components/formulario-ato/formulario-ato.component';
import { EditarConteudoAtoComponent } from './components/editar-conteudo-ato/editar-conteudo-ato.component';
import { FormsModule } from '@angular/forms';
import { AppSuiteRfbModule } from '../app-suite-rfb.module';
import { QuillModule } from 'ngx-quill';
import { GerirAtosComponent } from './components/gerir-atos/gerir-atos.component';
import { ImprimirAtoComponent } from './components/imprimir-ato/imprimir-ato.component';
import { VisualizarAtoComponent } from './components/visualizar-ato/visualizar-ato.component';
import { ExibirVisaoComponent } from './components/exibir-visao/exibir-visao.component';
import { VisaoRelacionalComponent } from './components/visao-relacional/visao-relacional.component';
import { CompararAtosComponent } from './components/comparar-atos/comparar-atos.component';
import { ListarAtosDuplicadosComponent } from './components/listar-atos-duplicados/listar-atos-duplicados.component';
import { VisualizarDiferencasComponent } from './components/visualizar-diferencas/visualizar-diferencas.component';

import { NgSelectModule } from '@ng-select/ng-select';
import { TiposSegmentoModule } from '../tipos-segmento/tipos-segmento.module';
import { LudsModule } from '../luds/luds.module';

@NgModule({
    declarations: [
        VisualizarAtoComponent,
        GerirAtosComponent,
        EditarAtoComponent,
        FormularioAtoComponent,
        EditarConteudoAtoComponent,
        ExibirVisaoComponent,
        VisaoRelacionalComponent,
        CompararAtosComponent,
        ListarAtosDuplicadosComponent,
        VisualizarDiferencasComponent,
        ImprimirAtoComponent
    ],
    imports: [
        CommonModule,
        DragDropModule,
        FormsModule,
        AppSuiteRfbModule,
        AtosRoutingModule,
        NgSelectModule,
        TiposSegmentoModule,
        LudsModule,
        QuillModule.forRoot()
    ],
    exports: [
        ExibirVisaoComponent,
        EditarConteudoAtoComponent
    ]
})
export class AtosModule { }

